import { makeStyles, createStyles } from '@material-ui/core/styles';

const headStyle = makeStyles((theme) =>
  createStyles({
    header: {
      background: '#000',
      padding: '20px 0',
    },
    headCont: {
      maxWidth: '82.5rem',
      width: '100%',
      margin: '0 auto',
      textAlign: 'center',
    },
    headLogo: {
      width: '125px',
      margin: '0 auto',
      [theme.breakpoints.down('sm')]: {
        width: '155px',
      },
    },
  })
);

export default headStyle;
